import { render, staticRenderFns } from "./templateWeight.vue?vue&type=template&id=68a271b2&scoped=true"
import script from "./templateWeight.vue?vue&type=script&lang=js"
export * from "./templateWeight.vue?vue&type=script&lang=js"
import style0 from "./templateWeight.vue?vue&type=style&index=0&id=68a271b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a271b2",
  null
  
)

export default component.exports